import React from 'react';
import IconCheckMark from 'components/Common/Icons/IconCheckMark';
import IconCheckMarkBox from 'components/Common/Icons/IconCheckMarkBox';

interface CheckMarkProps {
  checked: boolean;
}

const CheckMark: React.FC<CheckMarkProps> = ({ checked }) => (checked ? <IconCheckMark /> : <IconCheckMarkBox />);

export default CheckMark;
